import Chart from 'chart.js'
import { Line } from 'vue-chartjs'

export default {
  props: ['prices'],
  extends: Line,
  mounted () {
    this.renderChart(
      {
        datasets: [
          {
            label: 'Price evolution',
            borderColor: 'red',
            backgroundColor: 'red',
            fill: false,
            data: Object.values(this.prices).map(item => ({ x: item.quantity, y: item.price })),
            steppedLine: 'before'
          }
        ]
      },
      {
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            type: 'logarithmic',
            position: 'bottom',
            ticks: {
              userCallback: tick => {
                const remain = tick / (Math.pow(10, Math.floor(Chart.helpers.log10(tick))))
                if (remain === 1 || remain === 2 || remain === 5) {
                  return tick.toString()
                }
                return ''
              }
            }
          }],
          yAxes: [{
            type: 'linear',
            ticks: {
              min: 0
            }
          }]
        }
      }
    )
  }
}
